/* Gravur-MAX (Webstra 10/2026): Personalisierung nach den Produkt-Metafeldern (Teil 1, dazu -2.js und -3.js).
   Ergaenzt gm-layout-v2.js, ohne es zu veraendern. Muss VOR gm-layout-v2.js und wb-gravur-einzeln.js laden. */
(function(){
  if(window.__wbPers)return;window.__wbPers=1;
  var GM=window.GM=window.GM||{};
  var D={};
  try{D=JSON.parse(document.getElementById('wb-pers-data').textContent)||{};}catch(e){D={};}
  function $(s,r){return (r||document).querySelector(s);}
  function $$(s,r){return [].slice.call((r||document).querySelectorAll(s));}
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function fire(el,t){el.dispatchEvent(new Event(t,{bubbles:true}));}
  function txt(el){return el?(el.textContent||'').replace(/\s+/g,' ').trim():'';}
  function clean(s){return String(s||'').replace(/[\[\]]/g,'').replace(/\s+/g,' ').trim();}
  var TITLE=String(D.title||txt($('.product__info-container .product__title h1'))||'');
  function F(n){var f=(D.fields||[]).filter(function(x){return x.n===n;})[0];return f||null;}
  function numOf(inp){var m=String(inp&&inp.name||'').match(/Dein Wunschtext(\d+)\]$/);return m?+m[1]:0;}
  function glassOf(kind){var m=String(kind||'').match(/@(\d)/);return m?+m[1]:0;}
  function baseKind(kind){return String(kind||'').replace(/@\d/,'');}

  /* ---------- Daten-Ergaenzung: Spritz Queen / Spritz King (gleiche Position wie Aperol Queen/King) ---------- */
  (function(){
    var L=window.GM_LAY;if(!L)return;
    var add=[
      ['1g','spritz-queen-mit-wunschname','aperol-queen-mit-wunschname','Titelbild-1G-L_48e861b0-03cc-4f3d-8e36-99f606bc0e1a.jpg'],
      ['2g','spritz-queen-2-glaeser-mit-wunschname','aperol-queen-2-glaeser-mit-wunschname','Titelbild-2G-L_8840ed95-828d-463f-80a6-10456d738541.jpg'],
      ['1g','spritz-king-mit-wunschname','aperol-king-mit-wunschname','Titelbild-1G-L_14eb02fb-995e-42df-9168-901dd86ba05f.jpg'],
      ['2g','spritz-king-2-glaeser-mit-wunschname','aperol-king-2-glaeser-mit-wunschname','Titelbild-2G-L_7c245d78-5d00-4323-89f7-5d4a21b57b1f.jpg']
    ];
    var DY=0.006;
    ['gm-preview-puccini','gm-preview-puccini-aperol'].forEach(function(p){
      var f=L[p];if(!f||!f.m)return;
      add.forEach(function(a){
        var s=f.m[a[0]];if(!s||s[a[1]]||!s[a[2]])return;
        var E=JSON.parse(JSON.stringify(s[a[2]]));
        E.L=a[3];delete E.ov;delete E.V;
        (E.sl||[]).forEach(function(t){
          t[3]+=DY;
          if(t[9]&&t[9].length===4){t[9][1]+=DY;t[9][3]+=DY;}
          if(t[11]){t[11][0]+=DY;t[11][1]+=DY;}
        });
        s[a[1]]=E;
      });
    });
  })();

  /* ---------- Set-Regeln (vor wb-gravur-einzeln.js entscheiden) ---------- */
  var SETS=(D.sets||[]).map(function(s){return String(s&&s.t||'');}).filter(Boolean);
  if(!SETS.length)SETS=$$('.variant-option-v3 label').map(function(l){return (l.innerText||l.textContent||'').split('\n')[0].trim();});
  var hasSingle=SETS.some(function(t){return /^\s*1\s*Glas\b/i.test(t);});
  var heads=$$('[input-main-wapper]').map(function(g){return txt($('.namebox-heading',g))+' '+txt($('.font-heading',g));});
  var MRS=/MRS\.?\s*(ALWAYS\s*)?RIGHT/i.test(TITLE)||heads.some(function(h){return /Glas Mrs/i.test(h);});
  var fheads=$$('[input-main-wapper] .namebox-heading').map(txt);
  var COUPLE=MRS||fheads.some(function(h){return /(ersten|zweiten)\s+Wunschnamen|deine\s+Wunschnamen\s+ein/i.test(h);});
  var GLASS=/glas|krug/i.test(TITLE)&&!/Windlicht/i.test(TITLE);
  /* Nur "2 Glaeser" (ohne "1 Glas") oder Paerchenglas: alle Teile gleich, keine Einzel-Gravur */
  var SAME_ALL=GLASS&&(!hasSingle||COUPLE);
  /* Eigene Felder je Glas (Glas1/Glas2) regelt dieses Skript selbst (Haken "2. Glas genauso") */
  var PER_GLASS=heads.some(function(h){return /Glas\s*2\s*:/i.test(h);});
  if(SAME_ALL||PER_GLASS)window.__wbInd=1;
  var HOLZ=/Holzbox/i.test(TITLE);
  var PRE=String(window.GM_PREFIX||'');
  var MODE=/^gm-preview-tf-br-/.test(PRE)?'brett':/^gm-preview-tf-(k5|s5|s6|gl|st|th|nf|tp)-/.test(PRE)?'bottle':'';

  /* ---------- CSS ---------- */
  function css(){
    if($('#wb-pers-css'))return;
    var s=document.createElement('style');s.id='wb-pers-css';
    s.textContent=[
      '.gm-cfg .wb-opt{font-weight:400;color:#4f5a61}',
      '.gm-cfg .wb-note{margin:1.2rem 0 0;padding:1rem 1.2rem;border-radius:12px;background:#f4f8fa;color:#14232b;font-size:1.4rem;line-height:1.5}',
      '.gm-cfg .wb-note b{font-weight:700}',
      '.gm-cfg .wb-g{margin:0 0 1.6rem}',
      '.gm-cfg .wb-g + .wb-g{margin-top:1.6rem}',
      '.gm-cfg .wb-g__h{margin:0 0 1rem;font-size:1.5rem;font-weight:800;color:#14232b}',
      '.gm-cfg .wb-g .gm-field + .gm-fontbox,.gm-cfg .wb-g .gm-fontbox + .gm-field{margin-top:1.4rem}',
      '.gm-cfg .wb-g[hidden]{display:none}',
      '.gm-cfg .wb-same{display:flex;align-items:flex-start;gap:1.2rem;margin:1.6rem 0;padding:1.4rem 1.6rem;border:1.5px solid #d5e2e8;border-radius:14px;background:#fff;cursor:pointer;font-size:1.5rem;line-height:1.45;color:#14232b}',
      '.gm-cfg .wb-same input{flex:none;width:2.2rem;height:2.2rem;margin:.1rem 0 0;accent-color:#0b6e8a;cursor:pointer}',
      '.gm-cfg .wb-same:focus-within{outline:3px solid #0b6e8a;outline-offset:2px}',
      '.gm-cfg .wb-maxerr{margin:.6rem 0 0;font-size:1.3rem;font-weight:600;color:#b3261e}',
      '.gm-cfg .wb-bkf{margin-top:1.4rem}',
      '.gm-cfg .wb-bkf .gm-fonts{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.8rem;margin-top:.6rem}',
      '.gm-cfg .wb-bkf .wb-bkfont{display:flex;flex-direction:column;align-items:flex-start;gap:.2rem;min-height:6.4rem;padding:.8rem 1rem;border:1.5px solid #d5e2e8;border-radius:12px;background:#fff;color:#14232b;text-align:left;cursor:pointer}',
      '.gm-cfg .wb-bkf .wb-bkfont[aria-checked="true"]{border-color:#0b6e8a;box-shadow:0 0 0 2px #0b6e8a inset}',
      '.gm-cfg .wb-bkf .wb-bkfont:focus-visible{outline:3px solid #0b6e8a;outline-offset:2px}',
      '.gm-cfg .wb-bkf .wb-bkfont__s{font-size:2.1rem;line-height:1.3;white-space:nowrap;max-width:100%;min-height:2.8rem}',
      '.gm-cfg .wb-bkf .wb-bkfont__l{font-size:1.2rem;color:#4f5a61}',
      '.gm-cfg--lay .gm-svg text.wb-fx{white-space:pre}',
      '.gm-cfg--lay .gm-svg text.wb-fx.is-ph{fill-opacity:.6}',
      '@media (max-width:400px){.gm-cfg .wb-same{padding:1.2rem}}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- 1.1 Schritt-Titel aus den Metafeldern ---------- */
  function setStepTitle(step,t){
    if(!step||!t)return;
    var el=$('.gm-step__t',step);if(!el)return;
    var o=$('.gm-step__o',el);
    if(el.firstChild&&el.firstChild.nodeType===3&&o){el.firstChild.nodeValue=t+' ';}
    else if(!o&&txt(el)!==t){el.textContent=t;}
  }
  function stepTitles(){
    var info=$('.product__info-container');if(!info)return;
    var mot=$('variant-selects-cust.two-grid-option-swatch',info);
    if(mot&&D.swatchTitle){var a=mot.previousElementSibling;if(a&&a.classList.contains('gm-step'))setStepTitle(a,D.swatchTitle);}
    var set=$('.variant-option-v3',info);
    if(set&&D.variantTitle){var b=set.previousElementSibling;if(b&&b.classList.contains('gm-step'))setStepTitle(b,D.variantTitle);}
  }
  function renumber(){
    var info=$('.product__info-container');if(!info)return;
    var i=0;
    $$('.gm-step__n',info).forEach(function(n){var st=n.closest('.gm-step');if(st&&(st.hidden||st.offsetParent===null&&getComputedStyle(st).display==='none'))return;n.textContent=++i;});
  }

  /* ---------- 1.2 Zeichenbegrenzung fuer alle Felder ---------- */
  function applyMax(){
    $$('input[name^="properties[Dein Wunschtext"]').forEach(function(inp){
      var f=F(numOf(inp));
      var m=f&&+f.max>0?+f.max:0;
      if(!m){var h=inp.closest('[input-main-wapper]');var mm=h&&txt($('.namebox-heading',h)).match(/\((\d+)\s*\/\s*(\d+)\)/);if(mm)m=+mm[2];}
      if(m>0){inp.maxLength=m;if(inp.value&&inp.value!=='OHNE'&&inp.value.length>m)inp.value=inp.value.slice(0,m);}
    });
    (GM.rows||[]).forEach(function(r){if(r.input&&r.input.maxLength>0)r.max=r.input.maxLength;});
  }
  /* Sicherheitsnetz, falls ein Browser maxlength beim Einfuegen/IME nicht beachtet */
  document.addEventListener('input',function(e){
    var t=e.target;
    if(!t||t.tagName!=='INPUT'||!/^properties\[|^gm-bk-in$|^wb-ind-/.test(t.name||t.id||''))return;
    var m=t.maxLength;
    if(m>0&&t.value!=='OHNE'&&t.value.length>m){var p=t.selectionStart;t.value=t.value.slice(0,m);try{t.setSelectionRange(Math.min(p,m),Math.min(p,m));}catch(x){}}
  },true);

  function maxErr(inp,msg){
    var f=inp.closest('.gm-field')||inp.closest('.gm-bk__f')||inp.parentNode;
    var id=(inp.id||'wb')+'-maxerr';
    var p=document.getElementById(id);
    if(!msg){if(p)p.remove();if(inp.getAttribute('aria-describedby')===id)inp.removeAttribute('aria-describedby');return;}
    if(!p){p=document.createElement('p');p.id=id;p.className='wb-maxerr';p.setAttribute('role','alert');f.appendChild(p);}
    p.textContent=msg;inp.setAttribute('aria-invalid','true');inp.setAttribute('aria-describedby',id);
  }
  function checkMax(){
    var bad=null;
    $$('.product__info-container input[type=text]').forEach(function(inp){
      if(inp.disabled||!(inp.name&&/^properties\[/.test(inp.name))&&inp.id!=='gm-bk-in')return;
      var m=inp.maxLength,v=inp.value||'';
      if(m>0&&v!=='OHNE'&&v.length>m){maxErr(inp,'Bitte höchstens '+m+' Zeichen eingeben (aktuell '+v.length+').');bad=bad||inp;}
      else maxErr(inp,'');
    });
    return bad;
  }

  /* ---------- Hilfen fuer die Vorschau-Daten (wie gm-layout-v2.js) ---------- */
  function findLayout(){
    var f=(window.GM_LAY||{})[window.GM_PREFIX||'gm-preview-puccini'];
    if(!f)return null;
    var v='';
    $$('variant-selects-cust a.mo-item').forEach(function(a){if(a.getAttribute('href').split('?')[0]===location.pathname){var t=$('.item-title',a);v=t?t.textContent.trim():'';}});
    var h=txt($('.product__title h1'));
    var b=/holzbox\s+gro/i.test(h)?'2ghg':/holzbox\s+klein/i.test(h)?'1ghk':/2\s*Gl(ä|ae)ser/i.test(h)?'2g':/holzbox/i.test(h)?null:'1g';
    var x=location.pathname.split('/').pop().replace(/^weinglas-mit-gravur-leonardo-puccini-/,'');
    for(var y in f.m){if(f.m[y][x]&&f.sets[y]){b=y;break;}}
    if(!b||!f.sets[b]||!f.m[b])return null;
    var slug=String(v).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
    var E=f.m[b][x]||f.m[b][slug];
    return E?{E:E,set:f.sets[b],b:b}:null;
  }

  var ST={rows:[],mirror:null,ma:false,ready:false};

  /* ---------- Gemeinsame Helfer fuer wb-personalisierung-2.js / -3.js ---------- */
  var W=window.__WBP={D:D,$:$,$$:$$,esc:esc,fire:fire,txt:txt,clean:clean,F:F,numOf:numOf,glassOf:glassOf,baseKind:baseKind,TITLE:TITLE,MRS:MRS,COUPLE:COUPLE,GLASS:GLASS,SAME_ALL:SAME_ALL,HOLZ:HOLZ,MODE:MODE,ST:ST,css:css,setStepTitle:setStepTitle,stepTitles:stepTitles,renumber:renumber,applyMax:applyMax,findLayout:findLayout};

  /* ---------- Absenden: optionale Felder, Zeichenbegrenzung, Spiegeln ---------- */
  function preSubmit(e){
    var hit=e.type==='click'
      ?(e.target.closest&&e.target.closest('.product-form__submit, .shopify-payment-button__button, .gm-bar__btn, [data-wb-atc-btn], button[name="add"]'))
      :(e.target.closest&&e.target.closest('product-form, form[action*="/cart/add"]'));
    if(!hit||!$('.product__info-container'))return;
    if(e.type==='submit'&&!/^product-form-/.test(e.target.getAttribute&&e.target.getAttribute('id')||''))return;
    if(ST.mirror&&ST.mirror.on&&ST.mirror.sync)ST.mirror.sync();
    (ST.rows||[]).forEach(function(r){
      if(r.__opt&&!(r.input.value||'').trim()&&r.cb&&!r.cb.checked){r.cb.checked=true;fire(r.cb,'change');}
    });
    var bad=checkMax();
    if(bad){
      e.preventDefault();e.stopImmediatePropagation();
      var y=(bad.closest('.gm-field')||bad).getBoundingClientRect().top+window.pageYOffset-120;
      window.scrollTo({top:y,behavior:'smooth'});
      setTimeout(function(){try{bad.focus({preventScroll:true});}catch(x){bad.focus();}},60);
    }
  }
  document.addEventListener('click',preSubmit,true);
  document.addEventListener('submit',preSubmit,true);

  /* ---------- Sprechende Line-Item-Properties ---------- */
  var mainFormId=null;
  function formId(){
    if(mainFormId)return mainFormId;
    var i=$('input[name^="properties[Dein Wunschtext"][form]');
    mainFormId=i?i.getAttribute('form'):null;
    return mainFormId;
  }
  function transform(fd){
    if(!ST.ready||!ST.rows.length)return;
    var all=[];fd.forEach(function(v,k){all.push([k,v]);});
    var get=function(k){for(var i=0;i<all.length;i++)if(all[i][0]===k)return all[i][1];return null;};
    var out=[],done={};
    var ownRows=ST.rows.filter(function(r){return r.src===r&&r.font;});
    ST.rows.forEach(function(r){
      var k=r.input.name,v=get(k);
      if(v===null)return;
      out.push(['properties['+r.__short+']',v]);done[k]=1;
      if(r.font){
        var fk=r.font.name,fv=get(fk);
        if(r.src===r){
          var fl=ST.ma?r.__short.replace(' Text ',' Schrift '):ownRows.length>1?'Schriftart '+r.__short:'Schriftart';
          out.push(['properties['+fl+']',r.chosen||fv||'']);
        }else if(r.fixed&&fv){out.push(['properties[Schriftart '+r.__short+']',fv]);}
        done[fk]=1;
      }
    });
    if(ST.mirror&&ST.mirror.canToggle)out.push(['properties[2. Glas wie erstes Glas]',ST.mirror.on?'Ja':'Nein']);
    if(MRS&&HOLZ){var bt=W.mrsBoxText?W.mrsBoxText():'';if(bt)out.push(['properties[Holzbox]',bt]);}
    /* Einzel-Gravur (wb-gravur-einzeln.js): "Glas 2: <Feld>" mit kurzem Feldnamen */
    var rest=[];
    all.forEach(function(e){
      if(done[e[0]])return;
      var m=e[0].match(/^properties\[(Glas \d|Holzbox): (.+)\]$/);
      if(m){
        var inp=$$('input[name]').filter(function(i){return i.name===e[0];})[0];
        var km=inp&&inp.id&&inp.id.match(/^wb-ind-\d+-(.+)$/);
        var src=km&&ST.byKind[km[1]];
        if(src){rest.push(['properties['+m[1]+': '+src.__short+']',e[1]]);return;}
      }
      rest.push(e);
    });
    var keys={};all.forEach(function(e){keys[e[0]]=1;});
    Object.keys(keys).forEach(function(k){fd.delete(k);});
    out.concat(rest).forEach(function(e){fd.append(e[0],e[1]);});
  }
  (function(){
    var NF=window.FormData;if(!NF||NF.__wb)return;
    var WF=function(form,submitter){
      var fd=submitter!==undefined?new NF(form,submitter):form!==undefined?new NF(form):new NF();
      try{if(form&&form.getAttribute&&form.getAttribute('id')===formId()&&formId())transform(fd);}catch(e){if(window.console)console.warn('wb-pers props',e);}
      return fd;
    };
    WF.prototype=NF.prototype;WF.__wb=1;
    window.FormData=WF;
  })();

  /* ---------- Start ---------- */
  function poll(fn,max,ms){var n=0;(function f(){var ok=false;try{ok=fn();}catch(e){if(window.console)console.warn('wb-pers',e);ok=true;}if(!ok&&++n<max)setTimeout(f,ms);})();}
  W.poll=poll;
  function onReady(){
    if(onReady.done)return;onReady.done=1;
    applyMax();stepTitles();
    setTimeout(function(){stepTitles();renumber();},300);
    setTimeout(function(){stepTitles();if(W.bundleStep)W.bundleStep();renumber();},2700);
    if(W.lockBack)poll(W.lockBack,40,300);
  }
  document.addEventListener('gm:cfg-ready',function(){
    if(SAME_ALL||PER_GLASS){var w=$('.gm-cfg--lay');if(w)w.__wbInd=1;}
    setTimeout(function(){
      if(W.initCfg)poll(W.initCfg,20,150);
      if(W.fixedText)poll(W.fixedText,20,200);
      setTimeout(function(){if(W.bundleStep)W.bundleStep();renumber();},400);
    },120);
  });
  document.addEventListener('DOMContentLoaded',onReady);
  window.addEventListener('load',onReady);
  if(document.readyState==='complete')setTimeout(onReady,0);
})();